import { render, staticRenderFns } from "./AttendanceTerm.vue?vue&type=template&id=509fa1f3"
import script from "./AttendanceTerm.vue?vue&type=script&lang=js"
export * from "./AttendanceTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports